<div class="wrapper">
  <div class="background" [ngStyle]="(appTestEnvironment$ | async) ? { 'background-image': 'none' } : ''">
    <div class="background-overlay">
      <div class="d-flex justify-content-center align-items-center mt-5">
        <div class="row py-5">
          <div class="col-xs-1 col-md-2"></div>
          <div class="col-xs-10 col-md-8">
            <div>
              <div *ngIf="isRedirect" class="card">
                <div class="card-header text-white text-center">
                  <h1 class="title-heading">WE HAVE MOVED</h1>
                </div>
                <div class="card-body text-white">
                  <p class="text-center">Please update your bookmark to the new site address: {{ redirectURL }}</p>
                </div>
              </div>
              <div>
                <div *ngIf="appTestEnvironment$ | async" style="width: 100%; overflow: hidden; white-space: nowrap; box-sizing: border-box">
                  <div style="display: inline-block; padding-left: 100%; animation: marquee 10s linear infinite">NOTE: YOU ARE IN TEST MODE</div>
                </div>

                <div *ngIf="!isRedirect" class="card shadow rounded" style="background-color: rgba(0, 0, 0, 0.1)">
                  <div class="card-header text-white text-center pb-0 mb-0">
                    <h1 class="title-heading pb-0 mb-0">{{ applicationName }} LOGIN</h1>
                  </div>
                  <div style="background-color: rgba(0, 0, 0, 0.3)">
                    <div class="card-body text-white">
                      <p class="text-center">
                        Login here to allow raising of quotes and orders along with more accurate pricing and availability of stock. Employees should
                        login with their network username and external parties should use their email address. Companies that raise orders should
                        contact their sales rep to have an account setup.
                      </p>

                      <form [formGroup]="loginForm" class="login-container" (ngSubmit)="login()">
                        <div class="formGroup pb-2 row">
                          <div class="col-4">
                            <label>USERNAME / EMAIL<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-8">
                            <input type="username" class="form-control" placeholder="Username" formControlName="username" autofocus />
                          </div>
                        </div>
                        <div *ngIf="loginForm.controls.username.touched && loginForm.controls.username.invalid" class="text-white row">
                          <div class="offset-4 col-8">Username is required.</div>
                        </div>
                        <div class="formGroup py-2 row">
                          <div class="col-4">
                            <label>PASSWORD<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-8">
                            <input type="password" class="form-control" placeholder="Password" formControlName="password" />
                          </div>
                        </div>
                        <div class="text-white row">
                          <div *ngIf="isCaps" class="offset-4 col-8">CapsLock on</div>
                        </div>
                        <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.invalid" class="text-white row">
                          <div class="offset-4 col-8">Password is required.</div>
                        </div>
                        <div class="formGroup">
                          <div class="row pt-4">
                            <div class="offset-4 col-8 text-center">
                              <a class="text-white font-weight-bold" [routerLink]="['/forgot-password']">I'VE FORGOTTEN MY PASSWORD</a>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="offset-lg-4 col-lg-8 offset-3 col-9 text-lg-center d-flex justify-content-end">
                              <button type="submit" class="btn text-white" [disabled]="!loginForm.valid || (loading$ | async)">
                                <pos-app-spinner2 *ngIf="loading$ | async"></pos-app-spinner2>
                                LOGIN
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-1 col-md-2 col-xl"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-login-to [userProfile]="userProfile" (loggedIn)="redirectAfterLogin()" *ngIf="userProfile"></app-login-to>
</div>
